const dateTimeFormat = new Intl.DateTimeFormat(undefined, {
  dateStyle: 'short',
  timeStyle: 'medium',
});

const numberFormat = new Intl.NumberFormat(undefined, {
  style: 'decimal',
  useGrouping: true,
  minimumFractionDigits: 2,
});

const usdCurrencyFormat = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  useGrouping: true,
  minimumFractionDigits: 2,
});

const usdCurrencyFormatWhole = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  useGrouping: true,
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

function formatDateTime(d: Date): string {
  return dateTimeFormat.format(d);
}

function formatCentsAmount(amt: number): string {
  return numberFormat.format(amt / 100);
}

function formatName(lastName: string | undefined, firstName: string | undefined): string {
  return [firstName, lastName].filter((x) => !!x).join(' ');
}

const formatCentsCurrency = (amt: number): string => {
  return usdCurrencyFormat.format(amt / 100);
};

const formatCentsCurrencyWhole = (amt: number): string => {
  return usdCurrencyFormatWhole.format(amt / 100);
};

const formatBillingCycle = (billingCycle: number): string => {
  switch (billingCycle) {
    case 7:
      return 'weekly';
    case 14:
      return 'biweekly';
    case 30:
    default:
      return 'monthly';
  }
};

export {
  formatCentsAmount,
  formatDateTime,
  formatName,
  formatCentsCurrency,
  formatCentsCurrencyWhole,
  formatBillingCycle,
};
